import Vue from 'vue'
import Vuex from 'vuex'
import fccStore from 'pkgfe.fccbase/store'
import localDeProva from './localDeProva'
import acompanhamentoDeProjetos from './acompanhamentoDeProjetos'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseUrlPublicacao: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_PUBLICACAO,
    baseUrlLocalDeProva: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_LOCAL_DE_PROVA,
    baseUrlSir2: process.env.VUE_APP_API_BASE + process.env.VUE_APP_ISENCAO_REDUCAO,
    baseUrlGestaoForm: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_GESTAO_FORM,
    baseUrlSga: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_SGA,
    baseUrlSegurancaSGP: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_SEGURANCA,
    baseUrlAnaliseFotos: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_ANALISE_FOTOS,
    baseUrlGestaoProjetos: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_GESTAO_PROJETOS,
    baseUrlConcursos: process.env.VUE_APP_API_CONCURSOS,
    baseUrlRelatorios: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_RELATORIOS,
    baseUrlLaudoMedico: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_LAUDO_MEDICO,
    baseUrlEmails: process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_EMAILS,
    baseUrlNode: process.env.VUE_APP_NODE_JS + 'servicos_boletos/',
    baseUrlNodeApi: process.env.VUE_APP_NODE_JS + 'api/',
    baseUrlExterno: process.env.VUE_APP_URL_EXTERNO,
    baseUrlTransferenciaArquivos:
      process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_TRANSFERENCIA_ARQUIVOS,
    baseUrlBoleto: process.env.VUE_APP_API_BASE_CONCURSO + process.env.VUE_APP_BOLETO,
    albumfamilia: process.env.VUE_APP_FOTO_USER_URL,
    urlPrimeiroAcesso: process.env.VUE_APP_API_PRIMEIRO_ACESSO,
    urlRecuperaSenha: process.env.VUE_APP_RECUPERA_SENHA,
    urlCadastroExterno: process.env.VUE_APP_CADASTRO_EXTERNO,
    appIdSystem: process.env.VUE_APP_API_ID,
    permissaoMenu: {
      adicionar: 'I',
      editar: 'A',
      excluir: 'E',
      visualizar: 'V',
      consultar: 'C',
      executar: 'X',
      relatorios: 'R',
      incluir: 'I'
    },
    logo: fccStore.state.urlFccLogo,
    camposDinamicos: {
      idTipoVisualizacao: 1,
      opcoes: [
        'lstopcoes',
        'lstopcoesmultipla',
        'unicaescolha',
        'multiplaescolha',
        'declaracoes',
        'cidade',
        'ordenamultiplaescolha',
        'lstqueryhidden'
      ],
      query: ['lstquery', 'lstqueryhidden'],
      cargo: ['cargo'],
      uploadArquivos: ['upload'],
      ckeditor: ['textoinformativo', 'textoalerta', 'concatena'],
      text: ['textocurto'],
      maskText: ['email', 'text', 'url'],
      textLong: ['textolongo'],
      htmlAlternativas: ['rubrica']
    }
  },
  actions: {},
  getters: {},
  modules: {
    localDeProva,
    acompanhamentoDeProjetos
  }
})
